import { Heading4 } from "~/components/ui/Heading";
import { GameVer, useT } from "~/util/Lang";

import css from "./GverSelector.module.css";

export function GverSelector({
  selected,
  onToggle,
}: {
  selected: GameVer[];
  onToggle: (val: GameVer) => void;
}) {
  const t = useT();
  return (
    <>
      <Heading4>{t({ en: "Game Version", ru: "Версия игры" })}</Heading4>
      <div className={css.desc}>
        {t({
          en: "Select which chronicles this page will be displayed on, if nothing is selected, then the page will be displayed for all chronicles.",
          ru: "Выберите на каких хрониках будет отображаться эта страница, если ничего не выбрано, то страница будет отображаться для всех хроник.",
        })}
      </div>
      <div className={css.checkboxBlock}>
        {GameVer.options.map((ver) => (
          <label key={ver} className={css.checkbox}>
            <input
              type="checkbox"
              value={ver}
              checked={selected.includes(ver)}
              onChange={() => onToggle(ver)}
            />
            {ver}
          </label>
        ))}
      </div>
    </>
  );
}
